import React from "react";
import logo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { AUTH_STORAGE_KEYS } from "../api/authApi";

const API_BASE = process.env.REACT_APP_API_SERVER;

export default function Header() {
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      const response = await fetch(`${API_BASE}/wp-json/threecx/v1/logout`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        console.warn("Logout returned non-200:", response.status);
      }
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      localStorage.removeItem(AUTH_STORAGE_KEYS.hasSession);

      navigate("/login", { replace: true });
    }
  }

  return (
    <header className="fixed top-0 left-0 w-full">
      <div className="pl-[2.4242vw] pr-[2.4242vw] flex items-center justify-between">
        <div className="flex items-center space-x-1 w-[110px] h-[97px]">
          <img src={logo} alt="" />
        </div>

        <div className="flex items-center space-x-4 text-[#444]">
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white hover:bg-[#ffbf3c] hover:text-white transition text-sm"
          >
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
}
